import classNames from "classnames";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { DEFAULT_POLICY_SHOW } from "../Show/constants";
import AuthorProfile from "../Detail/components/AuthorProfile/component";
import Ad from "../../components/Ad/component";
import MaybeError from "../../components/MaybeError/component";
import PageAnalytics from "../../components/PageAnalytics";
import { getAuthorBioAnalytics } from "../../utils/analytics/library";
import { TYPE_AUTHOR } from "../../utils/analytics/constants";
import { fetchAuthorProfilePageData } from "./initData";
import ContentArea from "../../components/ContentArea/async.component";
import { fetch_author_load_more } from "../../actions/Author/dispatchers";

/**
 * Renders author profile page
 *
 * @param {Object} props The component props
 * @returns {React.Component} The Author Profile page component
 */
export function AuthorProfilePage({
    match,
    viewport = "",
    analyticsEnabled = true,
}) {
    const dispatch = useDispatch();

    const {
        statusCode,
        meta,
        title: pageTitle,
        contentId,
    } = useSelector((state) => state.app);

    useEffect(() => {
        if (match.params.contentId !== contentId) {
            dispatch(fetchAuthorProfilePageData(match.url, match.params));
        }
    }, []);

    const authorData = useSelector((state) => {
        return {
            profile: state.author.profile,
            stories: state.author.recentContent?.list,
            hasNextPage: state.author.recentContent?.hasNextPage,
        };
    });

    const contentProps = {
        content: authorData.stories,
        hasFeature: false,
        density: DEFAULT_POLICY_SHOW,
        viewport: viewport,
        listHeading: `Latest from ${authorData.profile?.name}`,
        className: "showContent",
        hasSidebar: false,
        loadMore: authorData.hasNextPage ?? false,
        loadMoreFetch: fetch_author_load_more(contentId),
    };

    const wrapperClasses = classNames(
        "authorProfilePage",
        "pageContentWrap",
        "pageComponent",
        viewport
    );
    const classes = classNames("contentArea", "show");

    const analyticsProps = getAuthorBioAnalytics({
        contentId: contentId,
        pageTitle: pageTitle,
        meta: meta,
        content: {
            contentType: "authorbio",
        },
        author: authorData.profile,
    });

    return (
        <MaybeError statusCode={statusCode}>
            <div className={wrapperClasses} data-testid="author-profile-page">
                <div className={"contentAreaWrap withSidebar"}>
                    <div className={classes}>
                        <AuthorProfile
                            json={authorData.profile}
                            authorProfilePage={true}
                        />
                        <ContentArea {...contentProps} />
                    </div>

                    <div className="sidebar">
                        <Ad type="bigbox" targeting={{ plc: "right" }} />
                    </div>
                </div>
                {analyticsEnabled && (
                    <PageAnalytics
                        dtmData={analyticsProps}
                        type={TYPE_AUTHOR}
                    />
                )}
            </div>
        </MaybeError>
    );
}

AuthorProfilePage.propTypes = {
    viewport: PropTypes.string,
    analyticsEnabled: PropTypes.bool,
};

export default AuthorProfilePage;
